import React from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PageHeroBanner } from '../../components/PageHeroBanner';
import { ServiceCTABanner } from '../../components/ServiceCTABanner';
import { CTAButton, CTABarOnBlue, MidPageCTAStrip } from '../../components/ServiceInlineCTA';
import { ArrowRightIcon, UsersIcon, WrenchIcon, LeafIcon, ClockIcon, DollarSignIcon, ThumbsUpIcon, ZapIcon, ShieldCheckIcon, TrendingUpIcon, SunIcon, HomeIcon, BuildingIcon, SearchIcon, SparklesIcon, BatteryChargingIcon, EyeIcon, GlobeIcon } from 'lucide-react';
const OTHER_SERVICES = [{
  name: 'Backyard Cleaning',
  slug: 'backyard-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/ahgarkrhWBWZi14WY7Vatg/lpw-service-backyard-cleaning-488x650.webp'
}, {
  name: 'Commercial Cleaning',
  slug: 'commercial-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/wNfvE2GAtkNAfy1MY4Qa6Y/bcpw-service-commercial-cleaning-576x1024.webp'
}, {
  name: 'Driveway Cleaning',
  slug: 'driveway-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp'
}, {
  name: 'Paver Cleaning',
  slug: 'paver-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp'
}, {
  name: 'Trash Can Cleaning',
  slug: 'trash-can-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/s8dNva1jhGj3tfrzpuizCn/lpw-service-trash-can-cleaning-488x650.webp'
}, {
  name: 'Window Cleaning',
  slug: 'window-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/4wiNEq1mR2Agh4kR5DHda3/lpw-service-window-cleaning-600x450.webp'
}];
const headingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 900 as const,
  lineHeight: 1.2
};
const bodyStyle = {
  color: '#025A8A',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  lineHeight: 1.8
};
const subHeadingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 800 as const,
  lineHeight: 1.3
};
export function SolarPanelCleaningPage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-1694">
      <Navbar data-id="element-1695" />
      <main data-id="element-1696">
        {/* Hero */}
        <PageHeroBanner eyebrow="Service" headline="Solar Panel Cleaning" subheadline="Our Solar Panel Cleaning services improve energy efficiency by removing dirt and debris with safe, eco-friendly methods, keeping your panels at peak performance for maximum energy savings." ctaPrimary={{
        label: 'Get A Free Quote',
        href: '#quote'
      }} ctaSecondary={{
        label: 'Get Started',
        href: '#contact'
      }} data-id="element-1697" />

        {/* Section — Service Overview (Split Layout) */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1698">
          <div className="max-w-7xl mx-auto" data-id="element-1699">
            <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16" data-id="element-1700">
              <div className="w-full lg:w-1/2" data-id="element-1701">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.15)'
              }} data-id="element-1702">
                  <img src="https://cdn.magicpatterns.com/uploads/7mkWmxZ6rJMX6ZT3SbVLdq/lpw-service-solar-panel-cleaning-577x1024.webp" alt="Solar Panel Cleaning Service" className="w-full h-auto object-cover" style={{
                  maxHeight: '500px'
                }} data-id="element-1703" />
                </div>
              </div>
              <div className="w-full lg:w-1/2" data-id="element-1704">
                <h2 className="font-bold mb-6" style={{
                ...headingStyle,
                fontSize: 'clamp(24px, 4vw, 30px)'
              }} data-id="element-1705">
                  Solar Panel Cleaning
                </h2>
                <p className="mb-4" style={bodyStyle} data-id="element-1706">
                  Our Solar Panel Cleaning services use safe, eco-friendly
                  methods to remove dirt and debris, improving your panels'
                  efficiency and energy output. With flexible scheduling and
                  expert care, we ensure your solar system performs at its best
                  for years to come.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButton data-id="element-1707" />

        {/* Section — Maximize Efficiency */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1708">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1709">
            <h2 className="font-bold mb-8" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1710">
              Solar Panel Cleaning Services: Maximize Your Energy Efficiency
              with Spotless Panels
            </h2>
            <p style={bodyStyle} data-id="element-1711">
              Solar panels are an excellent investment for reducing energy costs
              and minimizing your environmental footprint. However, to maintain
              their efficiency and prolong their lifespan, regular cleaning is
              essential. Dust, dirt, pollen, bird droppings, and other debris
              can accumulate on the surface of your solar panels, significantly
              reducing their ability to absorb sunlight and generate power. Our
              professional solar panel cleaning service ensures that your panels
              are spotless, operating at peak efficiency, and delivering the
              maximum energy output.
            </p>
          </div>
        </section>

        {/* Section — Why Cleaning is Important */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1712">
          <div className="max-w-7xl mx-auto" data-id="element-1713">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1714">
              Why Solar Panel Cleaning is Important
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1715">
              Solar panels are exposed to the elements year-round, making them
              vulnerable to dirt buildup. Without proper cleaning, they can lose
              up to 20% or more of their energy output.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1716">
              <div className="flex gap-5" data-id="element-1717">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1718">
                  <ZapIcon className="h-6 w-6 text-white" data-id="element-1719" />
                </div>
                <div data-id="element-1720">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1721">
                    Maximizes Energy Efficiency
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1722">
                    Even a thin layer of dust can block sunlight from reaching
                    your solar cells, reducing their energy production. Regular
                    cleaning ensures your panels are able to capture as much
                    sunlight as possible, helping you generate more electricity
                    and save money.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1723">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1724">
                  <ClockIcon className="h-6 w-6 text-white" data-id="element-1725" />
                </div>
                <div data-id="element-1726">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1727">
                    Prolongs Panel Lifespan
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1728">
                    Dirt and debris can cause long-term damage to your panels,
                    leading to costly repairs or replacements. Cleaning your
                    panels regularly prevents the buildup of corrosive
                    substances that can degrade the surface, extending their
                    lifespan.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1729">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1730">
                  <SparklesIcon className="h-6 w-6 text-white" data-id="element-1731" />
                </div>
                <div data-id="element-1732">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1733">
                    Prevents Permanent Staining
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1734">
                    Bird droppings, hard water stains, and sap can adhere to the
                    surface of solar panels and become difficult to remove if
                    left untreated. Regular cleaning helps prevent these stains
                    from setting in, keeping your panels looking and performing
                    like new.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1735">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1736">
                  <ShieldCheckIcon className="h-6 w-6 text-white" data-id="element-1737" />
                </div>
                <div data-id="element-1738">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1739">
                    Maintains Manufacturer's Warranty
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1740">
                    Many solar panel manufacturers require regular cleaning as
                    part of their warranty conditions. Neglecting to clean your
                    panels could void your warranty, leaving you responsible for
                    repairs or replacements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Our Cleaning Process */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1741">
          <div className="max-w-7xl mx-auto" data-id="element-1742">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1743">
              Our Comprehensive Solar Panel Cleaning Process
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1744">
              Cleaning solar panels requires specialized care to avoid damage
              and ensure optimal results. Our team uses professional-grade tools
              and eco-friendly solutions to clean your panels safely and
              effectively.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1745">
              <div className="p-8 rounded-2xl bg-white" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1746">
                <div className="flex items-center gap-4 mb-4" data-id="element-1747">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1748">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1749">
                      1
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1750">
                    Inspection and Assessment
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1751">
                  Before we begin cleaning, we conduct a thorough inspection of
                  your solar panel system to assess its condition. This allows
                  us to identify any areas of concern, such as dirt buildup,
                  debris, or damage. We also take note of any potential
                  obstructions, like overhanging trees or structures, that may
                  be contributing to the accumulation of dirt on your panels.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1752">
                <div className="flex items-center gap-4 mb-4" data-id="element-1753">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1754">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1755">
                      2
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1756">
                    Eco-Friendly Cleaning Solutions
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1757">
                  We use specially formulated, eco-friendly cleaning solutions
                  that are designed to remove dirt, grime, and bird droppings
                  without leaving streaks or causing damage to your solar
                  panels. These solutions are biodegradable and non-toxic,
                  ensuring they are safe for the environment, your property, and
                  your solar system.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1758">
                <div className="flex items-center gap-4 mb-4" data-id="element-1759">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1760">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1761">
                      3
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1762">
                    Soft Brush and Deionized Water Rinse
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1763">
                  To prevent scratching the surface of your solar panels, we use
                  soft-bristled brushes to gently remove dirt and debris. After
                  brushing, we rinse your panels with purified, deionized water.
                  This water is free of minerals and impurities, leaving your
                  panels spotless and streak-free.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1764">
                <div className="flex items-center gap-4 mb-4" data-id="element-1765">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1766">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1767">
                      4
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1768">
                    Debris Removal
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1769">
                  We remove any debris, such as leaves, branches, or bird nests,
                  that may have accumulated around your solar panels or in the
                  gaps between them. Clearing this debris ensures that airflow
                  and water drainage are not obstructed, preventing potential
                  damage to your panels.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white md:col-span-2 lg:col-span-1" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1770">
                <div className="flex items-center gap-4 mb-4" data-id="element-1771">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1772">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1773">
                      5
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1774">
                    Safety and Care
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1775">
                  Cleaning solar panels often involves working at heights, which
                  can be dangerous without the proper equipment and training.
                  Our team follows strict safety protocols, using harnesses,
                  ladders, and other safety gear to ensure a safe and effective
                  cleaning process. Whether your solar panels are on the roof or
                  mounted on the ground, we have the expertise to clean them
                  thoroughly.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA Bar */}
        <CTABarOnBlue data-id="element-1776" />

        {/* Section — Why Choose Us */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1777">
          <div className="max-w-7xl mx-auto" data-id="element-1778">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1779">
              Why Choose Our Solar Panel Cleaning Service?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1780">
              <div className="text-center p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1781">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1782">
                  <UsersIcon className="h-6 w-6 text-white" data-id="element-1783" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1784">
                  Trained Professionals
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1785">
                  Our team is experienced in handling solar panels of all types
                  and sizes. We understand the delicate nature of solar
                  technology and take every precaution to clean your panels
                  safely and effectively.
                </p>
              </div>

              <div className="text-center p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1786">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1787">
                  <LeafIcon className="h-6 w-6 text-white" data-id="element-1788" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1789">
                  Eco-Friendly Approach
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1790">
                  We prioritize the use of environmentally friendly cleaning
                  products and methods that are gentle on your panels and the
                  planet. Our deionized water system ensures that no harmful
                  chemicals are left behind.
                </p>
              </div>

              <div className="text-center p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1791">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1792">
                  <WrenchIcon className="h-6 w-6 text-white" data-id="element-1793" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1794">
                  State-of-the-Art Equipment
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1795">
                  We use specialized equipment designed for solar panel
                  cleaning, including soft brushes and deionized water systems
                  that leave your panels spotless without scratching or damaging
                  the surface.
                </p>
              </div>

              <div className="text-center p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1796">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1797">
                  <ZapIcon className="h-6 w-6 text-white" data-id="element-1798" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1799">
                  Increase Energy Output
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1800">
                  Our cleaning service helps you get the most out of your solar
                  investment by ensuring your panels are free from dirt and
                  debris, allowing them to operate at their maximum potential.
                </p>
              </div>

              <div className="text-center p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1801">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1802">
                  <ClockIcon className="h-6 w-6 text-white" data-id="element-1803" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1804">
                  Flexible Scheduling
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1805">
                  We offer flexible scheduling options to accommodate your
                  needs. Whether you need a one-time deep clean or regular
                  maintenance, we can work around your schedule.
                </p>
              </div>

              <div className="text-center p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1806">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1807">
                  <DollarSignIcon className="h-6 w-6 text-white" data-id="element-1808" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1809">
                  Affordable Pricing
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1810">
                  Our solar panel cleaning services are competitively priced,
                  offering you excellent value. We also offer discounted rates
                  for routine maintenance plans.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButton data-id="element-1811" />

        {/* Section — Benefits */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1812">
          <div className="max-w-7xl mx-auto" data-id="element-1813">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1814">
              Benefits of Regular Solar Panel Cleaning
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-1815">
              <div className="flex gap-5" data-id="element-1816">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1817">
                  <SunIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1818" />
                </div>
                <div data-id="element-1819">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1820">
                    Maximize Energy Production
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1821">
                    Clean solar panels absorb more sunlight, which directly
                    translates to increased energy output. Keep your panels
                    clean to generate more electricity and reduce your energy
                    bills.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1822">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1823">
                  <DollarSignIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1824" />
                </div>
                <div data-id="element-1825">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1826">
                    Save Money
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1827">
                    Dirty solar panels can reduce energy production by as much
                    as 20%. Regular cleaning ensures your panels operate at peak
                    efficiency, allowing you to get the most return on your
                    investment.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1828">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1829">
                  <ShieldCheckIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1830" />
                </div>
                <div data-id="element-1831">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1832">
                    Prevent Damage
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1833">
                    Regular cleaning prevents the buildup of corrosive materials
                    like bird droppings, sap, and hard water stains, which can
                    cause long-term damage to the surface of your panels.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1834">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1835">
                  <SearchIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1836" />
                </div>
                <div data-id="element-1837">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1838">
                    Maintain Warranty Compliance
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1839">
                    Many manufacturers require regular cleaning to maintain
                    warranty coverage. Schedule regular cleanings to ensure your
                    system stays in compliance.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1840">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1841">
                  <EyeIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1842" />
                </div>
                <div data-id="element-1843">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1844">
                    Improve Aesthetics
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1845">
                    Clean solar panels not only perform better but also look
                    better. A clean solar array enhances the appearance of your
                    property, boosting its curb appeal.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1846">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1847">
                  <GlobeIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1848" />
                </div>
                <div data-id="element-1849">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1850">
                    Environmental Impact
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1851">
                    By keeping your panels clean, you ensure that you're
                    maximizing their positive impact on the environment by
                    generating as much clean energy as possible.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mid-Page CTA Strip */}
        <MidPageCTAStrip data-id="element-1852" />

        {/* Section — Residential & Commercial */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1853">
          <div className="max-w-7xl mx-auto" data-id="element-1854">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1855">
              Solar Panel Cleaning for Residential and Commercial Properties
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1856">
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1857">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1858">
                  <HomeIcon className="h-6 w-6 text-white" data-id="element-1859" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '20px'
              }} data-id="element-1860">
                  Residential Solar Panels
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1861">
                  Maximize your home's energy efficiency with our professional
                  cleaning service, ensuring your rooftop solar panels are free
                  from dirt and debris.
                </p>
              </div>
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1862">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1863">
                  <BuildingIcon className="h-6 w-6 text-white" data-id="element-1864" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '20px'
              }} data-id="element-1865">
                  Commercial Solar Arrays
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1866">
                  For businesses with solar power systems, keeping panels clean
                  is essential for maintaining optimal energy production. We
                  offer scalable solutions for large commercial solar arrays,
                  ensuring your business continues to benefit from clean energy.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Maintenance Plans */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1867">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1868">
            <h2 className="font-bold mb-6" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1869">
              Regular Solar Panel Maintenance Plans
            </h2>
            <p style={bodyStyle} data-id="element-1870">
              We recommend scheduling solar panel cleanings at least twice a
              year to ensure optimal performance, especially in areas prone to
              dust, pollen, or bird droppings. Our maintenance plans allow you
              to schedule regular cleanings at convenient intervals, ensuring
              your panels remain in top condition year-round.
            </p>
          </div>
        </section>

        {/* Section — Other Services */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1871">
          <div className="max-w-7xl mx-auto" data-id="element-1872">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 30px)'
          }} data-id="element-1873">
              Explore Our Other Services
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-1874">
              {OTHER_SERVICES.map(service => <a key={service.slug} href={`/services/${service.slug}`} className="bg-white rounded-xl p-5 text-center transition-all hover:shadow-lg hover:scale-[1.02] flex flex-col items-center gap-3 border" style={{
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)',
              borderColor: '#E8F4FD'
            }} data-id="element-1875">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1876">
                    <img src={service.img} alt={service.name} className="w-full h-full object-cover" data-id="element-1877" />
                  </div>
                  <p className="font-bold text-sm" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '13px'
              }} data-id="element-1878">
                    {service.name}
                  </p>
                  <span className="flex items-center gap-1 text-xs font-semibold" style={{
                color: '#0283C7',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1879">
                    Learn More <ArrowRightIcon className="h-3 w-3" data-id="element-1880" />
                  </span>
                </a>)}
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <ServiceCTABanner headline="Ready to Boost Your Solar Energy Output?" data-id="element-1881" />
      </main>
      <Footer data-id="element-1882" />
    </div>;
}